import {
  Button,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerOverlay,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  useDisclosure,
  useMediaQuery,
} from '@chakra-ui/react';
import { MdUploadFile } from 'react-icons/md';
import FormProjectDocumentContent from './FormProjectDocumentContent';

interface IOwnProps {
  registrationId: string;
  stepId: string;
  submissionId: string;
  refetchData?: () => void;
  disabled?: boolean;
}

const FormProjectDocumentButton: React.FC<IOwnProps> = ({ registrationId, stepId, submissionId, refetchData, disabled = false }) => {
  const [isMobile] = useMediaQuery('(max-width: 1024px)');
  const disclosureModal = useDisclosure();

  const closeModal = () => {
    disclosureModal.onClose();
  };

  return (
    <>
      <Button
        leftIcon={<MdUploadFile />}
        colorScheme="blue"
        size="sm"
        onClick={disclosureModal.onOpen}
        isDisabled={disabled}
      >
        Adicionar arquivo
      </Button>

      {isMobile && (
        <Drawer placement={'bottom'} isOpen={disclosureModal.isOpen} onClose={disclosureModal.onClose}>
          <DrawerOverlay />

          <DrawerContent maxH={'90%'}>
            <DrawerBody p={0}>
              <FormProjectDocumentContent
                refetchData={refetchData}
                closeModal={closeModal}
                registrationId={registrationId}
                stepId={stepId}
                submissionId={submissionId}
              />
            </DrawerBody>
          </DrawerContent>
        </Drawer>
      )}

      {!isMobile && (
        <Modal isOpen={disclosureModal.isOpen} onClose={disclosureModal.onClose} isCentered>
          <ModalOverlay />
          <ModalContent pb={10} maxW={'90%'} minH="90%">
            <ModalBody display="flex" flexDir="column" gap={1}>
              <FormProjectDocumentContent
                refetchData={refetchData}
                closeModal={closeModal}
                registrationId={registrationId}
                stepId={stepId}
                submissionId={submissionId}
              />
            </ModalBody>
          </ModalContent>
        </Modal>
      )}
    </>
  );
};

export default FormProjectDocumentButton;
